import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Layout from "../Components/Layout/Layout";
import Dropdown from "react-bootstrap/Dropdown";
import Pagination from "react-bootstrap/Pagination";
import { useDispatch } from "react-redux";
import { getTransaction, getuserprofile } from "../Redux/Actions/AdminActions";
import placeholder from "../Assets/Images/Road-assistance-placehodler.png";
import { BsFileEarmarkPdf } from "react-icons/bs";
import ImagePreviewModal from "../Common/ImagePreviewModal";

const statusMap = {
  0: "N/A",
  1: "Pending",
  2: "Completed",
  3: "Cancelled",
};

const getBookingStatus = (details) => {
  if (!details) return 'N/A';
  if (details.cancelledBy) return 'Cancelled';
  if (details.isComplete) return 'Completed';
  if (details.isReached) return 'Reached';
  if (details.isAccepted) return 'Accepted';
  return 'N/A';
};


export default function TransactionDetails() {
  const url = process.env.REACT_APP_FILE_BASE_URL;

  const [transactiondetails, setTransactiondetails] = useState("");
  const [imageModal, setImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const dispatch = useDispatch();
  const { id } = useParams();

  useEffect(() => {
    dispatch(getTransaction({ id: id }))
      .then((response) => {
        if (response?.payload?.data?.status === 200) {
          setTransactiondetails(response?.payload?.data?.data);
        }
      })
      .catch((error) => {
        console.log(error, "Error occur");
      });
  }, [id, dispatch]);

  const handlePrivewImagesOpen = (img) => {
    setImageModal(true);
    setSelectedImage(img);
  };

  const handlePrivewImagesClose = () => {
    setImageModal(false);
    setSelectedImage("");
  };


  return (
    <Layout>
      <Container fluid>
        <div className="py-4">
          {/* User Overview Cards */}
          <div className="row justify-content-center g-4">
            <div className="col-md-4">
              <div className="card shadow-sm h-100">
                <div className="card-body text-center">
                  <img
                    src={
                      transactiondetails?.userId?.profileImage
                        ? `${url}${transactiondetails?.userId?.profileImage}`
                        : placeholder
                    }
                    alt="Profile"
                    className="rounded-circle mb-3"
                    style={{ width: "100px", height: "100px", objectFit: "cover" }}
                  />
                  <h6 className="text-uppercase text-muted mb-3">User Details</h6>
                  <ul className="list-unstyled text-start small">
                    <li className="mb-2">
                      <strong>Username:</strong> {transactiondetails?.userId?.name || "N/A"}
                    </li>
                    <li className="mb-2">
                      <strong>Email:</strong> {transactiondetails?.userId?.email || "N/A"}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card shadow-sm h-100">
                <div className="card-body text-center">
                  <img
                    src={
                      transactiondetails?.acceptedBy?.profileImage
                        ? `${url}${transactiondetails?.acceptedBy?.profileImage}`
                        : placeholder
                    }
                    alt="Profile"
                    className="rounded-circle mb-3"
                    style={{ width: "100px", height: "100px", objectFit: "cover" }}
                  />
                  <h6 className="text-uppercase text-muted mb-3">Driver Details</h6>
                  <ul className="list-unstyled text-start small">
                    <li className="mb-2">
                      <strong>Username:</strong> {transactiondetails?.acceptedBy?.name || "N/A"}
                    </li>
                    <li className="mb-2">
                      <strong>Email:</strong> {transactiondetails?.acceptedBy?.email || "N/A"}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card shadow-sm h-100">
                <div className="card-body text-center">
                  <img
                    src={
                      transactiondetails?.serviceId?.service_image
                        ? `${url}${transactiondetails?.serviceId?.service_image}`
                        : placeholder
                    }
                    alt="Profile"
                    className="rounded-circle mb-3"
                    style={{ width: "100px", height: "100px", objectFit: "cover" }}
                  />
                  <h6 className="text-uppercase text-muted mb-3">Service Details</h6>
                  <ul className="list-unstyled text-start small">
                    <li className="mb-2">
                      <strong>Service Name:</strong> {transactiondetails?.serviceId?.service_name || "N/A"}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Company Details */}
          <div className="card mt-5 shadow-sm">
            <h5 className="card-header text-center bg-primary text-white">
              Transaction Details
            </h5>
            <div className="card-body">
              <div className="row g-4">
                <div className="col-md-6 col-lg-4">
                  <div className="border rounded p-3 h-100">
                    <strong>Booking Status:</strong>
                    <p className="text-muted mb-0">
                      {getBookingStatus(transactiondetails)}
                    </p>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4">
                  <div className="border rounded p-3 h-100">
                    <strong>Payment Status:</strong>
                    <p className="text-muted mb-0">{statusMap[transactiondetails?.paymentData?.payment_status] || "N/A"}</p>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4">
                  <div className="border rounded p-3 h-100">
                    <strong>Paid Amount:</strong>
                    <p className="text-muted mb-0">${transactiondetails?.paymentData?.total_amount || "0"}</p>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4">
                  <div className="border rounded p-3 h-100">
                    <strong>Received Amount:</strong>
                    <p className="text-muted mb-0">${transactiondetails?.paymentData?.amount?.toFixed(2) || "0"}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="text-center mt-5">
            <p className="text-muted">
              © {new Date().getFullYear()}, Made with ❤️ by <span className="fw-bold">Codobux</span>
            </p>
          </div>
        </div>

        <ImagePreviewModal
          handlePrivewImagesClose={handlePrivewImagesClose}
          imageModal={imageModal}
          selectedImage={selectedImage}
        />
      </Container>
    </Layout>
  );
}
